export default __webpack_public_path__ + "images/background_1920-2.jpg";